// Customer reviews shown on the landing page. Hand-picked from the admin
// review list (5-star, from users who had downloaded a file) — the longer
// reviews are split into one-line pull quotes. Photos are copies of
// the review uploads, re-encoded to webp with all metadata stripped.

export interface ReviewPhoto {
  src: string
  alt: string
}

export interface Testimonial {
  quote: string
  author: string
  /** The reviewer's own photo, when they attached one. */
  photo?: ReviewPhoto
}

export const WALL_PHOTO: ReviewPhoto = {
  src: '/images/reviews/review-wall-yosemite-everest-zion.webp',
  alt: 'Three framed Terrain 6 prints hanging on a wall — Yosemite Half Dome Trail, Mount Everest, and Zion Angels Landing',
}

export const SLOVAKIA_PHOTO: ReviewPhoto = {
  src: '/images/reviews/review-slovakia-puzzles.webp',
  alt: 'Four Terrain 6 puzzles of the Slovak mountains laid out on a cutting mat — the High and Western Tatras, Malá Fatra, Liptovská kotlina, and Demänovská dolina',
}

const AZLINE = 'Azline'
const BETA_MEMBER = 'Beta member'
// Their display name is an auto-generated handle, so credit the plan instead.
const LIFETIME_MEMBER = 'Lifetime member'

/** The hero ticker's rotation, in order — the first one is shown on load. */
export const HERO_TESTIMONIALS: Testimonial[] = [
  {
    quote: 'Every model I’ve downloaded has printed without an issue.',
    author: AZLINE,
    photo: WALL_PHOTO,
  },
  { quote: 'Terrain 6 is perfect.', author: BETA_MEMBER, photo: SLOVAKIA_PHOTO },
  { quote: 'A lot of new options have been added and it’s great.', author: LIFETIME_MEMBER },
  { quote: 'The site is extremely easy to use.', author: AZLINE, photo: WALL_PHOTO },
  {
    quote: 'I recommend it to anyone interested in topography.',
    author: BETA_MEMBER,
    photo: SLOVAKIA_PHOTO,
  },
  {
    quote: 'Once you load the file, it’s just a matter of picking your colors.',
    author: AZLINE,
    photo: WALL_PHOTO,
  },
]
